const KeenSlider = window.KeenSlider

const { setInitialised, useA11y, useArrows } = window.BAO.Carousel.plugins

class HotspotCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
    this.modalCarousel = this.setupModalCarousel()

    if (this.els.modal?.element) {
      this.els.modal.element.setAttribute('inert', '')
      this.els.modal.element.setAttribute('aria-hidden', 'true')
    }

    // eslint-disable-next-line compat/compat
    this.observer = new IntersectionObserver(this.onEntry.bind(this), {
      rootMargin: '-45%',
      threshold: 0,
    })

    this.observer.observe(this)
  }

  setupListeners () {
    super.setupListeners()

    this.handleTriggerClick = this.handleTriggerClick.bind(this)
    this.handleOpen = this.handleOpen.bind(this)
    this.handleClose = this.handleClose.bind(this)

    this.els.trigger?.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.handleTriggerClick)
    })

    if (
      window.BAO.MediaBreakpoints.isSmViewport ||
      window.BAO.MediaBreakpoints.isXsViewport
    ) {
      this.els.trigger?.elements.forEach((triggerEl) => {
        this.listeners.add(triggerEl, 'click', this.handleOpen)
      })
    }

    this.els['modal-trigger']?.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.handleOpen)
    })

    this.els?.close?.elements.forEach((closeEl) => {
      this.listeners.add(closeEl, 'click', this.handleClose)
    })
  }

  onEntry ([entry], observer) {
    if (!entry.isIntersecting) return

    this.classList.add('sec-Hotspots-active')

    observer.unobserve(this)
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 2,
          spacing: 5,
        },
        breakpoints: {
          '(min-width: 901px)': {
            renderMode: 'custom',
            loop: true,
            slides: {
              perView: 1,
              spacing: 5,
            },
          },
        },
        created: (instance) => {
          this.updateTriggerAriaCurrent(instance.track.details.rel)
        },
        slideChanged: (instance) => {
          const activeIndex = instance.track.details.rel

          this.els.slide.elements.forEach((slideEl) => {
            slideEl.setAttribute(
              'aria-hidden',
              slideEl.dataset.index !== activeIndex.toString(),
            )
          })

          this.updateTriggerAriaCurrent(activeIndex)
        },
      },
      [
        setInitialised(),
        useA11y({
          includeRole: false,
          includeLabel: false,
          includeRoleDescription: false,
        }),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }

  setupModalCarousel () {
    if (!this.els['modal-slide']?.exists) return

    return new KeenSlider(
      this.els['modal-slides'].element,
      {
        selector: this.els['modal-slide'].selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 2,
          spacing: 10,
        },
        created: (instance) => {
          this.updateTriggerAriaCurrent(instance.track.details.rel)
        },
        slideChanged: (instance) => {
          const activeIndex = instance.track.details.rel

          this.els['modal-slide'].elements.forEach((slideEl) => {
            slideEl.setAttribute(
              'aria-hidden',
              slideEl.dataset.index !== activeIndex.toString(),
            )
          })

          this.updateTriggerAriaCurrent(activeIndex)
        },
      },
      [
        setInitialised(),
        useA11y(),
        useArrows({
          next: this.els['modal-next']?.element,
          previous: this.els['modal-previous']?.element,
        }),
      ],
    )
  }

  handleOpen () {
    this.lastFocusedElement = document.activeElement

    this.els.modal.element.removeAttribute('inert')
    this.els.modal.element.setAttribute('aria-hidden', 'false')
    this.els.modal.element.showModal()
    document.body.classList.toggle('util-SiteOverfloewd', true)
  }

  handleClose () {
    this.els.modal.element.close()
    this.els.modal.element.setAttribute('inert', '')
    this.els.modal.element.setAttribute('aria-hidden', 'true')

    if (this.lastFocusedElement instanceof HTMLElement) {
      this.lastFocusedElement.focus()
    }

    document.body.classList.toggle('util-SiteOverflowed', false)
  }

  updateTriggerAriaCurrent (activeIndex) {
    if (!this.els.trigger?.exists) return

    this.els.trigger.elements.forEach((triggerEl) => {
      const isCurrent = triggerEl.dataset.index === activeIndex.toString()
      triggerEl.setAttribute('aria-current', String(isCurrent))
    })
  }

  handleTriggerClick (event) {
    const clickedTrigger = event.target.closest(this.els.trigger.selector)
    const targetIndex = parseInt(clickedTrigger.dataset.index, 10)

    if (window.BAO.MediaBreakpoints.isMd) {
      this.carousel?.moveToIdx(targetIndex)
      this.modalCarousel?.moveToIdx(targetIndex)
    } else {
      this.handleOpen()

      window.setTimeout(() => {
        this.carousel?.moveToIdx(targetIndex)
        this.modalCarousel?.moveToIdx(targetIndex)
      }, 750)
    }
  }
}

if (!customElements.get('hotspot-carousel')) {
  customElements.define('hotspot-carousel', HotspotCarousel)
}
